import SHOP from '../../assets/projects_images/shop-website.png'
import FACEAPP from '../../assets/projects_images/faceapp.png'
import TODO from '../../assets/projects_images/TODO.png'
import MAP from '../../assets/projects_images/MAP.png'
import VUEAPP from '../../assets/projects_images/shopping-cart.png'
import WORDLE from '../../assets/projects_images/WORDLE.png'
import REACTWORDLE from '../../assets/projects_images/react-wordle.png'
import CALCULATOR from '../../assets/projects_images/js-calculator.png'

const data_projects = [
    {
        name: 'Clothing Store',
        image: SHOP,
        deployed_url: 'https://chimerical-kangaroo-a784c7.netlify.app/',
        github_url: 'https://github.com/rafimohammad839/E-Commerce-Website',
        category: [ 'react.js']
    },
    {
        name: 'Distance Matrix Routing App',
        image: MAP,
        deployed_url: 'https://codesandbox.io/s/goofy-tu-94oqi/',
        github_url: 'https://github.com/rafimohammad839/Distance-Matrix-Routing-App-React-Js',
        category: [ 'react.js']
    },
    {
        name: 'Face Recognition Brain',
        image: FACEAPP,
        deployed_url: 'https://codesandbox.io/s/jolly-shape-38ujsj',
        github_url: 'https://github.com/rafimohammad839/Face-Recognition-Brain',
        category: ['react.js']
    },
    {
        name: 'Wordle Clone',
        image: REACTWORDLE,
        deployed_url: 'https://bestwordlegame.netlify.app/',
        github_url: 'https://github.com/rafimohammad839/React-Wordle',
        category: ['react.js']
    },
    {
        name: 'To-Do-List',
        image: TODO,
        deployed_url: 'https://codesandbox.io/s/kind-moore-id4u2v',
        github_url: 'https://github.com/rafimohammad839/To-do-List---React-Js',
        category: ['react.js']
    },
    {
        name: 'Mini Shopping App',
        image: VUEAPP,
        deployed_url: 'https://github.com/rafimohammad839/A-Mini-Shopping-App',
        github_url: 'https://github.com/rafimohammad839/A-Mini-Shopping-App',
        category: ['vue.js']
    },
    {
        name: 'Wordle Game',
        image: WORDLE,
        deployed_url: 'https://github.com/rafimohammad839/A-Mini-Shopping-App',
        github_url: 'https://github.com/rafimohammad839/A-Mini-Shopping-App',
        category: ['javascript']
    },
    {
        name: 'Calculator',
        image: CALCULATOR,
        deployed_url: 'https://codesandbox.io/s/fast-moon-r3h2ry',
        github_url: 'https://github.com/rafimohammad839/Calculator',
        category: ['javascript']
    },
]

export default data_projects;